import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { formatRgb } from "./materialsCatalog";

const MaterialsCatalogRow = ({ material }) => {
  const { t } = useTranslation();
  const rgb = formatRgb(material.displayColor);

  const copyColorCode = async () => {
    if (!material.displayColor) return;
    try {
      await navigator.clipboard.writeText(material.displayColor);
      toast.success(t("materialsCatalog.colorCopied"), {
        className: "custom-toast",
      });
    } catch {
      toast.error(t("materialsCatalog.colorCopyFailed"), {
        className: "custom-toast",
      });
    }
  };

  return (
    <article className="table-standard-row">
      <div className="table-standard-row-cell">
        <span
          className="materials-catalog-row__swatch"
          style={{
            backgroundColor: material.displayColor || "transparent",
          }}
          aria-hidden
        />
        <span className="materials-catalog-row__name">{material.name}</span>
      </div>
      <div className="table-standard-row-cell">
        <span className="table-standard-row-cell-truncate">
          {material.categoryLabel}
        </span>
      </div>
      <div className="table-standard-row-cell">
        <div className="container-status-group">
          {/* La caractérisation retient toutes les matières ; le monitoring
              n'en retient que celles marquées en erreur de tri. */}
          <span className="container-status-badge container-status-badge--ok">
            {t("materialsCatalog.scopeCharacterization")}
          </span>
          <span
            className={`container-status-badge ${
              material.inSortingErrors
                ? "container-status-badge--ok"
                : "container-status-badge--ko"
            }`}
          >
            {t("materialsCatalog.scopeMonitoring")}
          </span>
        </div>
      </div>
      <div className="table-standard-row-cell">
        <span
          className={`materials-catalog-row__recyclability${
            material.recoverable
              ? ""
              : " materials-catalog-row__recyclability--negative"
          }`}
        >
          {material.recoverable
            ? t("materialsCatalog.recyclable")
            : t("materialsCatalog.notRecyclable")}
        </span>
      </div>
      <div className="table-standard-row-cell">
        {material.displayColor ? (
          <button
            type="button"
            className="materials-catalog-row__color-code"
            onClick={copyColorCode}
            title={rgb || undefined}
            aria-label={`${t("materialsCatalog.copyColorAria")} ${material.name}`}
          >
            <code>{material.displayColor}</code>
            <i className="fas fa-copy" aria-hidden />
          </button>
        ) : (
          <span>—</span>
        )}
      </div>
    </article>
  );
};

export default MaterialsCatalogRow;
